import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    padding: 0,
    '&.MuiStepConnector-vertical > .MuiStepConnector-line': {
      marginLeft: 4,
    },
    '&.apollo-theme-interactive .MuiStep-root': {
      cursor: 'pointer',
    },
    '&:not(.apollo-theme-interactive)': {
      pointerEvents: 'none',
    },
    '& .apollo-theme-disabled .MuiStepLabel-root': {
      opacity: 0.4,
    },
    '& .apollo-theme-dot + div': {
      '&.Mui-active, &.Mui-completed': {
        '&.MuiStepConnector-vertical > .MuiStepConnector-line': {
          backgroundColor: idsTokens.stepper.default.color.incomplete.path.enabled,
        },
      },
    },
    '& .apollo-theme-dot.Mui-completed + div': {
      '&.Mui-completed, &.Mui-active': {
        '&.MuiStepConnector-vertical > .MuiStepConnector-line': {
          backgroundColor: idsTokens.stepper.default.color.completed.path.enabled,
        },
      },
    },
  },
  horizontal: {
    '&:has(.apollo-theme-box)': {
      gap: idsTokens.stepper.default.spacing.boxGroup.gap,
    },
  },
  vertical: {
    '& .MuiStepLabel-iconContainer:not(.Mui-completed):not(.Mui-active)': {
      marginLeft: 1,
      marginRight: -1,
    },
  },
});
